import { createRoot } from "react-dom/client";
import React from 'react';
import App from "./App";
import { HelmetProvider } from 'react-helmet-async';
import "./index.css";

class ErrorBoundary extends React.Component<{children:React.ReactNode},{error:any}> {
  constructor(props:any){
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error:any){
    return { error };
  }
  componentDidCatch(error:any, info:any){
    console.error('Runtime error boundary caught:', error, info);
  }
  render(){
    if(this.state.error){
      const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
      const msg = String((this.state.error as any)?.message || this.state.error || 'Unknown error');
      const looksLikeChunk = /loading chunk|dynamically imported module|failed to fetch/i.test(msg);
      const title = offline
        ? "You’re offline"
        : (looksLikeChunk ? 'Page failed to load' : 'Something went wrong');
      const description = offline
        ? 'Your connection dropped. Reconnect to continue.'
        : (looksLikeChunk
            ? 'We could not load this page. Please try again.'
            : 'Please refresh the page to recover.');

      return (
        <div className="min-h-screen bg-[hsl(226,26%,7%)] text-[hsl(210,9%,91%)] flex items-center justify-center p-6">
          <div className="w-full max-w-lg border border-[#1C2A44] bg-[hsl(215,15%,14%)] rounded-2xl p-6">
            <div className="text-lg font-semibold text-white mb-2">{title}</div>
            <div className="text-sm text-white/80 mb-4">{description}</div>
            <div className="flex gap-3">
              <button
                className="px-4 py-2 rounded-lg bg-[#4C73FF] text-white text-sm font-semibold hover:brightness-110"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
              <button
                className="px-4 py-2 rounded-lg border border-[#4C73FF] text-[#4C73FF] text-sm font-semibold hover:bg-[#4C73FF] hover:text-white"
                onClick={() => (window.location.href = '/')}
              >
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </HelmetProvider>
);
